/**
 * Link Component
 */

import React, { forwardRef } from 'react';
import { AnchorElement } from './link.style';
import { LinkDecorationTypes, LinkProps, LinkTypes, LinkRef } from './link.types';

const DEFAULT_DATA_ATTR = { 'data-testid': 'link' };

const Link = forwardRef(
  (
    {
      url,
      ariaLabel,
      children,
      className,
      dataAttr = {},
      decoration = LinkDecorationTypes.NONE,
      download = false,
      downloadName,
      handlers = {},
      rel,
      target,
      type = LinkTypes.PRIMARY,
      ...otherProps
    }: LinkProps,
    ref: LinkRef,
  ) => {
    // Call the handler when the event is triggered
    const invokeHandler = (hType: string, e?: Event) => {
      handlers[hType](e);
    };
    const handlerProps: { [key: string]: (e: Event) => void } = {};
    Object.keys(handlers).forEach((key: string) => {
      handlerProps[key] = (e: Event) => {
        invokeHandler(key, e);
      };
    });

    // Construct the download attr
    const downloadAttr: boolean | string = download ? downloadName || true : false;
    const combinedDataAttr = { ...DEFAULT_DATA_ATTR, ...dataAttr };

    return (
      <AnchorElement
        className={className}
        download={downloadAttr}
        href={url}
        rel={rel}
        target={target}
        {...combinedDataAttr}
        {...handlerProps}
        aria-label={ariaLabel}
        decoration={decoration}
        ref={ref}
        type={type}
        {...otherProps}
      >
        {children}
      </AnchorElement>
    );
  },
);

export default Link;
